import { Link } from "react-router-dom";
import { httpPost } from "../../http/request";
import { useUsuario } from "../../context/UsuarioContext";
import { useGoogleLogin } from "@react-oauth/google";
import { mostrarAlertaDanger } from "../../functions/alertas";

const LoginGoogle2 = () => {
  const { setToken, tkApp } = useUsuario();

  const loginGoogle = (r) => {
    r["tkApp"] = tkApp;
    console.log(r);
    httpPost(r, "/api/v1/login/signGoogle").then((d) => {
      console.log(d);
      if (d) {
        setToken(d.token);
      }
    });
  };

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => loginGoogle(codeResponse),
    error_callback: () => {
      mostrarAlertaDanger("ocurrió un error al iniciar con Google");
    },
  });
  return (
    <div className="container-fluid vh-100 d-flex flex-column flex-md-row p-0">
      {/* Izquierda - Login */}
      <div className="col-md-6 bg-white d-flex flex-column justify-content-center align-items-center text-center p-4 h-100">
        <div className="mb-4">
          <h1 className="fw-bold text-primary">SIGTA</h1>
          <p className="text-muted mb-0">Sistema de Gestión de Trámites</p>
          <p className="fw-semibold text-secondary">Universidad Amazónica de Pando</p>
        </div>

        <div className="h-100 d-flex">
          <div className="my-auto ">
            <h2 className="fw-bold mb-3 d-block d-md-none">¿Quieres ser parte de la UAP?</h2>
            <p className="mb-2">Ingresa con tu cuenta de Google</p>
            <div className="d-flex">
              <button
                className="btn btn-outline-secondary d-flex align-items-center justify-content-center gap-2 px-4 py-2 rounded-pill mb-5 mx-auto"
                onClick={() => login()}
              >
                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/google/google-original.svg" alt="Google" style={{ width: "20px" }} />
                <strong>Iniciar sesión con Google</strong>
              </button>
            </div>
          </div>
        </div>

        {/* Logo en el fondo en escritorio */}
        <img
          src="https://sigta.uap.edu.bo/static/media/LOGOS_UAP_AZUL.671bdb5a507678839e89.png"
          alt="Logo UAP"
          className="opacity-25 mt-auto d-none d-md-block"
          style={{ width: "180px" }}
        />

        <footer className="mt-auto small text-black-50 d-block d-md-none">
          <p className="mb-0">Universidad Amazónica de Pando</p>
          <strong>Dirección de Información Académica</strong>
        </footer>
      </div>

      {/* Derecha - Postulación (solo visible en escritorio) */}
      <div className="col-md-6 bg-danger text-white d-none d-md-flex flex-column justify-content-center align-items-center text-center p-5">
        <div className="h-100 d-flex">
          <div className="m-auto">
            <h2 className="fw-bold mb-2">¿Quieres ser parte de la UAP?</h2>
            <p className="mb-4">Registra tu postulación aquí</p>

            <Link className="btn btn-light fw-semibold mb-4" onClick={() => login()}>
              Postúlate
            </Link>
          </div>
        </div>

        <footer className="mt-auto small text-white-50">
          <p className="mb-0">Universidad Amazónica de Pando</p>
          <strong>Dirección de Información Académica</strong>
        </footer>
      </div>
    </div>
  );
};

export default LoginGoogle2;
